/* eslint-disable react/prop-types */
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import { Button } from 'react-bootstrap';
import Select from 'react-select';

export const AdvanceTableFooter = ({
  page,
  pageSize,
  pageIndex,
  rowCount,
  setPageSize,
  canPreviousPage,
  canNextPage,
  nextPage,
  previousPage,
  rowInfo,
  rowsPerPageSelection,
  navButtons,
  rowsPerPageOptions = [5, 10, 15],
  className
}) => {
  const pageSizeOptions = rowsPerPageOptions.map(value => ({
    value,
    label: String(value)
  }));
  return (
    <Flex
      className={classNames(
        className,
        'align-items-center justify-content-between flex-wrap'
      )}
    >
      <Flex alignItems="center" className="fs--1 mb-2 mb-md-0">
        {rowInfo && (
          <p className="mb-0">
            <span className="d-none d-sm-inline-block me-2">
              Viendo del {pageSize * pageIndex + 1} al{' '}
              {pageSize * pageIndex + page.length} de {rowCount} total
            </span>
          </p>
        )}
        {rowsPerPageSelection && (
          <div className="d-flex align-items-center mt-2 mt-md-0">
            <p className="mb-0 mx-2">Fila por página:</p>
            <Select
              className="w-auto"
              isSearchable={false}
              value={pageSizeOptions.find(option => option.value === pageSize)}
              onChange={selectedOption => setPageSize(selectedOption.value)}
              options={pageSizeOptions}
            />
          </div>
        )}
      </Flex>
      {navButtons && (
        <Flex className="mt-2 mt-md-0">
          <Button
            size="sm"
            variant={canPreviousPage ? 'primary' : 'light'}
            onClick={() => previousPage()}
            className={classNames({ disabled: !canPreviousPage })}
          >
            Anterior
          </Button>
          <Button
            size="sm"
            variant={canNextPage ? 'primary' : 'light'}
            className={classNames('px-4 ms-2', {
              disabled: !canNextPage
            })}
            onClick={() => nextPage()}
          >
            Siguiente
          </Button>
        </Flex>
      )}
    </Flex>
  );
};

export default AdvanceTableFooter;
